import React from 'react'

function Cart() {
  return (
    <div>
      
    </div>
  )
}

export default Cart
